import type { JsonType } from 'posthog-js';

export interface MeetWeaveMedia {
  videoUrl: string;
  posterUrl: string;
}

const isHttpsUrl = (value: unknown): value is string => typeof value === 'string' && value.startsWith('https://');

/**
 * Resolves the Meet Weave welcome-modal artwork URLs from the `meet-weave-modal-media` PostHog flag
 * payload, falling back to the bundled asset per field. Payload shape: `{ videoUrl?, posterUrl? }`.
 *
 * Each field falls back independently, so the flag can override just the video, just the poster, or both;
 * any non-string / non-https / missing value uses the fallback — a misconfigured payload can never blank
 * or downgrade the modal. Lets the clip be swapped from the PostHog dashboard without a code release.
 */
export function resolveMeetWeaveMedia(variantData: JsonType | undefined, fallback: MeetWeaveMedia): MeetWeaveMedia {
  const payload =
    variantData && typeof variantData === 'object' && !Array.isArray(variantData)
      ? (variantData as Record<string, JsonType>)
      : {};
  return {
    videoUrl: isHttpsUrl(payload.videoUrl) ? payload.videoUrl : fallback.videoUrl,
    posterUrl: isHttpsUrl(payload.posterUrl) ? payload.posterUrl : fallback.posterUrl,
  };
}
